import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { DinnersPage } from './pages/DinnersPage';
import { JournalsPage } from './pages/JournalsPage';
export function App() {
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/dinners" element={<DinnersPage data-id="element-5" />} data-id="element-4" />
        <Route path="/journals" element={<JournalsPage data-id="element-7" />} data-id="element-6" />
        {/* Fallback for other routes */}
        <Route path="*" element={<LandingPage data-id="element-9" />} data-id="element-8" />
      </Routes>
    </Router>;
}